/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HistoryDescription } from './historyDescription';


export interface History { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    actionPerformed: History.ActionPerformedEnum;
    entityType: History.EntityTypeEnum;
    referenceId: string;
    referenceName?: string;
    description?: HistoryDescription;
    newStatus?: string;
    updatedData?: object;
    addedFiles?: Array<string>;
    removedFiles?: Array<string>;
    addedMembers?: Array<string>;
    removedMembers?: Array<string>;
    projectId?: string;
    subProjectId?: string;
    taskId?: string;
    propertyName?: string;
    oldValue?: string;
    newValue?: string;
}
export namespace History {
    export type ActionPerformedEnum = 'Item_Created' | 'Item_Uploaded' | 'Status_Changed' | 'Info_Changed' | 'UsageRights_Added' | 'UsageRights_Changed' | 'UsageRights_Deleted' | 'Item_Deleted' | 'File_Changed' | 'Team_Changed' | 'Item_Published' | 'Item_UnPublished' | 'Item_Downloaded' | 'Cover_Image_Changed' | 'New_Version_Added' | 'New_Variant_Added' | 'File_Format_Deleted' | 'Item_Shared' | 'Tag_Added' | 'Tag_Removed' | 'Tag_Edited' | 'Tag_Deleted' | 'Owner_Added' | 'Owner_Removed' | 'Item_Added_To_Collection' | 'Item_Removed_From_Collection' | 'Relation_Created' | 'Relation_Removed' | 'Expired';
    export const ActionPerformedEnum = {
        ItemCreated: 'Item_Created' as ActionPerformedEnum,
        ItemUploaded: 'Item_Uploaded' as ActionPerformedEnum,
        StatusChanged: 'Status_Changed' as ActionPerformedEnum,
        InfoChanged: 'Info_Changed' as ActionPerformedEnum,
        UsageRightsAdded: 'UsageRights_Added' as ActionPerformedEnum,
        UsageRightsChanged: 'UsageRights_Changed' as ActionPerformedEnum,
        UsageRightsDeleted: 'UsageRights_Deleted' as ActionPerformedEnum,
        ItemDeleted: 'Item_Deleted' as ActionPerformedEnum,
        FileChanged: 'File_Changed' as ActionPerformedEnum,
        TeamChanged: 'Team_Changed' as ActionPerformedEnum,
        ItemPublished: 'Item_Published' as ActionPerformedEnum,
        ItemUnPublished: 'Item_UnPublished' as ActionPerformedEnum,
        ItemDownloaded: 'Item_Downloaded' as ActionPerformedEnum,
        CoverImageChanged: 'Cover_Image_Changed' as ActionPerformedEnum,
        NewVersionAdded: 'New_Version_Added' as ActionPerformedEnum,
        NewVariantAdded: 'New_Variant_Added' as ActionPerformedEnum,
        FileFormatDeleted: 'File_Format_Deleted' as ActionPerformedEnum,
        ItemShared: 'Item_Shared' as ActionPerformedEnum,
        TagAdded: 'Tag_Added' as ActionPerformedEnum,
        TagRemoved: 'Tag_Removed' as ActionPerformedEnum,
        TagEdited: 'Tag_Edited' as ActionPerformedEnum,
        TagDeleted: 'Tag_Deleted' as ActionPerformedEnum,
        OwnerAdded: 'Owner_Added' as ActionPerformedEnum,
        OwnerRemoved: 'Owner_Removed' as ActionPerformedEnum,
        ItemAddedToCollection: 'Item_Added_To_Collection' as ActionPerformedEnum,
        ItemRemovedFromCollection: 'Item_Removed_From_Collection' as ActionPerformedEnum,
        RelationCreated: 'Relation_Created' as ActionPerformedEnum,
        RelationRemoved: 'Relation_Removed' as ActionPerformedEnum,
        Expired: 'Expired' as ActionPerformedEnum
    };
    export type EntityTypeEnum = 'Project' | 'Sub-Project' | 'Task' | 'Sub-Task' | 'Asset' | 'Collection' | 'Tag';
    export const EntityTypeEnum = {
        Project: 'Project' as EntityTypeEnum,
        SubProject: 'Sub-Project' as EntityTypeEnum,
        Task: 'Task' as EntityTypeEnum,
        SubTask: 'Sub-Task' as EntityTypeEnum,
        Asset: 'Asset' as EntityTypeEnum,
        Collection: 'Collection' as EntityTypeEnum,
        Tag: 'Tag' as EntityTypeEnum
    };
}


